"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseLayerFactory_3857 = void 0;
var BaseLayerType_1 = require("../baselayers/BaseLayerType");
var BaseLayer_1 = require("./BaseLayer");
var Tile_1 = require("ol/layer/Tile");
var BingMaps_1 = require("ol/source/BingMaps");
var OSM_1 = require("ol/source/OSM");
var DualBaseLayerWithResolutionSwitch_1 = require("./DualBaseLayerWithResolutionSwitch");
var BaseLayerFactory_3857 = /** @class */ (function () {
    function BaseLayerFactory_3857() {
    }
    BaseLayerFactory_3857.prototype.GetBaseLayerByType = function (baseLayerType, bingApiKey, esdmApiKey) {
        if (bingApiKey === void 0) { bingApiKey = ""; }
        if (esdmApiKey === void 0) { esdmApiKey = ""; }
        var lyr = null;
        switch (baseLayerType) {
            case BaseLayerType_1.BaseLayerType.OSM:
                lyr = this.OSM("OpenStreetMap", "OpenStreetMap");
                break;
            case BaseLayerType_1.BaseLayerType.BingAerial:
                lyr = this.BingAerial(bingApiKey, "BingAerial", "Bing Aerial");
                break;
            case BaseLayerType_1.BaseLayerType.BingRoad:
                lyr = this.BingRoad(bingApiKey, "RoadOnDemand", "Bing Road");
                break;
            case BaseLayerType_1.BaseLayerType.BingOS:
                var bingOS = this.GetBinglayer(bingApiKey, "OrdnanceSurvey", 17);
                bingOS.setVisible(false);
                var bingRoad = this.GetBinglayer(bingApiKey, "RoadOnDemand");
                bingRoad.setVisible(false);
                lyr = new DualBaseLayerWithResolutionSwitch_1.DualBaseLayerWithResolutionSwitch("BingOS", "Bing Ordnance Survey", bingOS, bingRoad, 11);
                break;
            case BaseLayerType_1.BaseLayerType.OSM_ESDM_contours:
                lyr = this.OSM_ESDM_contours(esdmApiKey, "OSM_ESDM_contours", "OpenStreetMap");
                break;
            case BaseLayerType_1.BaseLayerType.OSM_ESDM_nocontours:
                lyr = this.OSM_ESDM_nocontours(esdmApiKey, "OSM_ESDM_nocontours", "OpenStreetMap");
                break;
            case BaseLayerType_1.BaseLayerType.OS_Open_Data:
                console.warn("".concat(baseLayerType, " layer not configured for 3857, layer is only available in 27700"));
                break;
            default:
                console.warn("".concat(baseLayerType, " layer not configured for 3857"));
                break;
        }
        return lyr;
    };
    BaseLayerFactory_3857.prototype.BingAerial = function (apiKey, ref, displayName) {
        var lyr = this.GetBinglayer(apiKey, "Aerial");
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_3857.prototype.BingOS = function (apiKey, ref, displayName) {
        var lyr = this.GetBinglayer(apiKey, "OrdnanceSurvey", 16);
        lyr.getSource().setAttributions('© Crown Copyright and database right ' + new Date().getFullYear() + '. All rights reserved.Ordnance Survey Licence number 100023706');
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_3857.prototype.BingRoad = function (apiKey, ref, displayName) {
        var lyr = this.GetBinglayer(apiKey, "RoadOnDemand");
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_3857.prototype.GetBinglayer = function (apiKey, imagerySet, maxZoom) {
        if (maxZoom === void 0) { maxZoom = 0; }
        var opts = {
            key: apiKey,
            imagerySet: imagerySet,
            culture: 'en-gb'
        };
        if (maxZoom > 0) {
            opts.maxZoom = maxZoom;
        }
        return new Tile_1.default({
            source: new BingMaps_1.default(opts)
        });
    };
    BaseLayerFactory_3857.prototype.OSM = function (ref, displayName) {
        var lyr = new Tile_1.default({
            source: new OSM_1.default()
        });
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_3857.prototype.OSM_ESDM_contours = function (apiKey, ref, displayName) {
        var lyr = new Tile_1.default({
            source: new OSM_1.default({
                url: "//{a-f}.osm.esdm.co.uk/900913/c/{z}/{x}/{y}.png?APIKEY=".concat(apiKey),
                maxZoom: 18
            })
        });
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    BaseLayerFactory_3857.prototype.OSM_ESDM_nocontours = function (apiKey, ref, displayName) {
        var lyr = new Tile_1.default({
            source: new OSM_1.default({
                url: "//{a-f}.osm.esdm.co.uk/900913/u/{z}/{x}/{y}.png?APIKEY=".concat(apiKey),
                maxZoom: 18
            })
        });
        return new BaseLayer_1.BaseLayer(ref, displayName, lyr);
    };
    return BaseLayerFactory_3857;
}());
exports.BaseLayerFactory_3857 = BaseLayerFactory_3857;
//# sourceMappingURL=BaseLayerFactory_3857.js.map